import { gql } from '@apollo/client'

export const GET_BUSINESS_CLIENT_KREDITS_SETTINGS = gql`
  query GetBusinessClientKreditsSettings($id: UUID!) {
    businessClient(id: $id) {
      id
      kreditsSettings {
        businessSites {
          id
          name
          categories {
            amount
            frequency {
              unit
              value
            }
            name
          }
        }
        categories {
          amount
          frequency {
            unit
            value
          }
          name
        }
      }
    }
  }
`

export const GET_KREDITS = gql`
  query GetKredits($input: KreditsInput!, $pagination: Pagination) {
    kredits(input: $input, pagination: $pagination) {
      total
      items {
        id
        balance
        businessCustomer {
          id
          category
        }
        businessClient {
          id
          name
          isKreditEnabled
        }
        businessSite {
          id
          name
        }
        accounts {
          type
          balance
        }
        user {
          id
          userFullName
          email
          phone
        }
      }
    }
  }
`

export const GET_KREDIT = gql`
  query GetKredit($id: ID!) {
    kredit(input: { id: $id }) {
      id
      balance
      user {
        id
        userFullName
        email
        phone
      }
    }
  }
`

export const GET_KREDIT_TRANSACTIONS = gql`
  query GetKreditTransactions($input: KreditTransactionsInput!, $pagination: Pagination) {
    kreditTransactions(input: $input, pagination: $pagination) {
      total
      items {
        id
        createdAt
        amount
        accounts
        type
        source {
          ... on TransactionSourceBooking {
            bookingID
          }
          ... on TransactionSourceSale {
            salesChannelID
          }
          ... on TransactionSourceCorporate {
            dispersionID
          }
          ... on TransactionSourceMobileLine {
            number
          }
          ... on TransactionSourceAdmin {
            userID
          }
        }
      }
    }
  }
`
